import { Component, OnInit } from '@angular/core';

import { NgbModal, NgbActiveModal, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Table } from '../../../models/table/table.model';
import { Column } from '../../../models/table/column.model';
import { InnerDimension } from '../../../models/table/inner-dimension.model';
import { Row } from '../../../models/table/row.model';
import { InnerRow } from '../../../models/table/inner-row.model';
import { RowValue } from '../../../models/table/row-value.model';
import { InnerRowValue } from '../../../models/table/inner-row-value.model';

import { BarchartVertical } from '../../../models/barchart/barchart-vertical.model';
import { BarchartHorizontal } from '../../../models/barchart/barchart-horizontal.model';
import { Databar } from '../../../models/databar/databar.model';
import { Piechart } from '../../../models/piechart/piechart.model';
import { Linechart } from '../../../models/linechart/linechart.model';

import { BubbleChart } from '../../../models/bubblechart/bubble-chart.model';
import { InterpolatedChart } from '../../../models/interpolatedChart/interpolated-chart.model';

import { DashboardService } from '../services/dashboard.service';

import { ToastrService } from 'ngx-toastr';

import { MatTabChangeEvent } from '@angular/material';
import { AnalysisService } from '../services/analysis.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  itemLocal = JSON.parse(localStorage.getItem('localUser'));
  facility = JSON.parse(localStorage.getItem('localFacilities'));
  id = JSON.parse(localStorage.getItem('localID'));
  tag = JSON.parse(localStorage.getItem('localTags'));
  idElaboration = JSON.parse(localStorage.getItem('localIDElaboration'));
  modules = JSON.parse(localStorage.getItem('localModules'));

  access_token = this.itemLocal.accessToken
  expires = this.itemLocal.expires
  tokenDeadline = new Date(this.expires);
  currentFacility = this.facility[this.id];
  currentTag = this.tag[this.currentFacility.myFacilities.IdTag]

  //Temporary logos of the monitored channels
  facebookLogo: any = require("../image/canali/Facebook.png");
  foursquareLogo: any = require("../image/canali/Foursquare.png");
  GoogleAnalyticsLogo: any = require("../image/canali/GoogleAnalytics.png");
  twitterLogo: any = require("../image/canali/Twitter.png");
  tripAdvisorLogo: any = require("../image/canali/Tripadvisor.png");
  bookingLogo: any = require("../image/canali/Booking.png");

  agodaLogo: any = require("../image/canali/Agoda.png");
  ebookersLogo: any = require("../image/canali/Ebookers.png");
  expediaLogo: any = require("../image/canali/Expedia.png");
  holidayCheckLogo: any = require("../image/canali/HolidayCheck.png");
  hotwireLogo: any = require("../image/canali/Hotwire.png");

  //Icon NavBar
  homeImage: any = require("../image/navbar/backHomeIcon.svg");
  summaryImage: any = require("../image/navbar/summary.svg");
  analysisImage: any = require("../image/navbar/analysis.svg");
  roiImage: any = require("../image/navbar/roi.svg");
  mdiImage: any = require("../image/navbar/mdi.svg");
  pprImage: any = require("../image/navbar/ppr.svg");

  dashboard: any;
  areas: Array<any>;
  elaborations: Array<any> = [];
  lastTabEvent: MatTabChangeEvent;

  modalReference: any;
  isOpen: boolean;
  _opened: boolean = false;

  //Color array of charts
  chartColors = ['#2F7AB0', '#F8B62D', '#AD1D2A', '#D42568', '#7A2B6F', '#3B9745', '#858585', '#83AFCF', '#FBD272', '#CE767D', '#E67BA4', '#AE7FAA', '#88BF8F', '#DADADA'];

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private modal: NgbActiveModal,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private configCarousel: NgbCarouselConfig,
    private analysisService: AnalysisService
  ) {
    this.matIconRegistry.addSvgIcon("back", this.domSanitizer.bypassSecurityTrustResourceUrl(this.homeImage));
    this.matIconRegistry.addSvgIcon("all", this.domSanitizer.bypassSecurityTrustResourceUrl(this.summaryImage));
    this.matIconRegistry.addSvgIcon("Analysis", this.domSanitizer.bypassSecurityTrustResourceUrl(this.analysisImage));
    this.matIconRegistry.addSvgIcon("MDI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.mdiImage));
    this.matIconRegistry.addSvgIcon("PPR", this.domSanitizer.bypassSecurityTrustResourceUrl(this.pprImage));
    this.matIconRegistry.addSvgIcon("ROI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.roiImage));
    this.configCarousel.interval = 0;
  }

  ngOnInit() {

    this.translate.use(localStorage.getItem('localLanguage'));

    this.isOpen = false;

    this.getDashboard();
    this.horizontalPhone();
  }

  _toggleSidebar() {
    this._opened = !this._opened;
  }

  openVerticallyCentered(content) {
    this.modalReference = this.modalService.open(content, { centered: true });
  }

  close() {
    this.modalReference.close();
  }

  openIndicators(row) {
    row.isOpen = true;
  }

  closeIndicators(row) {
    row.isOpen = false;
  }

  horizontalPhone() {
    if (window.screen.width <= 425) {
      this.translate.get('PORTRAIT_PHONE.TITLE').subscribe((res: string) => {
        this.toastr.info(res, null, {
          positionClass: 'toast-top-center',
          timeOut: 4000
        })
      });
    }
  }

  // API return Dashboard
  getDashboard() {
    this.areas = [];
    this.dashboardService.getDashboard(this.idElaboration, this.currentFacility.myFacilities.IdTag)
      .subscribe(
        data => {
          this.dashboard = data;
          for (let area of this.dashboard.Aree) {
            this.areas.push({
              id: area.AreaId,
              name: area.AreaName,
              score: area.Score,
              elaborations: [],
              elements: []
            });
          }
          this.getElaborations(0);
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }

  getElaborations(currentPage: number, itemsNumberPerPage: number = 10) {
    //Call Api of Analys service to get Timeline of current facility.
    this.analysisService.getTimeline(this.currentFacility.myFacilities.IdAnalysis, ["analysis"], currentPage, itemsNumberPerPage)
      .subscribe(data => {
        data.items.filter(elab => (elab.button.isPresent && elab.state == "Report")).forEach(elab => {
          if (!this.elaborations.filter(e => e.id == elab.id).length) this.elaborations.push({
            date: elab.timestamp,
            id: elab.id,
            selected: elab.id == this.idElaboration
          });
        });
        if ((data.currentPage + 1) * data.requestItemsNumberPerPage < data.totalItemsCount) this.getElaborations(data.currentPage + 1);
      });
  }

  changeElaboration(elaboration) {
    if (elaboration.id == this.idElaboration) return;
    elaboration.selected = !elaboration.selected;
    this.getDashboardDetails(this.lastTabEvent);
  }

  // API Return Dashboard Details
  getDashboardDetails(event: MatTabChangeEvent) {
    if (!event || event.index < 1 || !this.elaborations.length) return;
    this.lastTabEvent = event;
    const selectedElaborations = this.elaborations.filter(elab => elab.selected).map(elab => elab.id);
    const selectedArea = this.areas[event.index - 1];

    //se ne deseleziono uno, rimuovo tutte le elaborazioni per ricaricare i grafici
    if (selectedArea.elaborations.filter(id => !selectedElaborations.includes(id)).length) {
      this.areas[event.index - 1].elaborations = [];
      this.areas[event.index - 1].elements = [];
    }

    //aggiungo le elaborazioni mancanti
    selectedElaborations.filter(id => !selectedArea.elaborations.includes(id)).forEach(id => {
      this.dashboardService.getDashboardDetails(selectedArea.id, id)
        .subscribe(data => {
          selectedArea.elaborations.push(id);

          for (let element of data.Elements) {
            var guiElement = selectedArea.elements.filter(el => el.title == element.Title)[0];
            if (!guiElement) {
              guiElement = { title: element.Title, graphics: [] };
              selectedArea.elements.push(guiElement);
            }
            var old = guiElement.graphics.filter(graphic => graphic.type == element.Type)[0];
            if (old) old = old.data;

            switch (element.Type) {
              case 'table':
                this.createTable(guiElement, element, old);
                break;
              case 'vertical_barchart':
                if (element.InnerElements.length > 0 && element.InnerElements.filter(element => element.Type != "simple_table").length) this.createInterpolatedChart(guiElement, element, element.InnerElements, old);
                else this.createBarchartVertical(guiElement, element, old);

                element.InnerElements.filter(element => element.Type == "simple_table").forEach(st => {
                  this.createSimpleTable(guiElement, st, element.Title);
                });
                break;
              case 'databars':
                if (!old) this.createDatabar(guiElement, element);
                break;
              case 'piechart':
                this.createPiechart(guiElement, element, old);
                break;
              case 'linechart':
                if (element.InnerElements.length > 0) this.createInterpolatedChart(guiElement, element, element.InnerElements, old);
                else this.createLinechart(guiElement, element, old);
                break;
              case 'horizontal_barchart':
                this.createBarchartHorizontal(guiElement, element, old);
                break;
              case 'bubblechart':
                this.createBubblechart(guiElement, element, old);
                break;
            }
          }
        }, error => {
          var elab = this.elaborations.filter(elaboration => elaboration.id == id)[0];
          elab.selected = false;
          this.translate.get('PROCESSING.TITLE').subscribe((res: string) => {
            this.toastr.error(res + " " + this.datepipe.transform(elab.date, 'dd/MM/yyy HH:mm') + " - Error", null, {
              positionClass: 'toast-top-center',
              timeOut: 4000
            })
          });
        });
    });
  }

  //Table chart
  createTable(guiElement, currentTable, table: Table) {
    //Instance of child Table Object.   
    if (!table) {
      table = new Table;
      table.title = currentTable.Title;
      guiElement.graphics.push({ type: currentTable.Type, data: table });
    }

    let columnIdArray: string[] = []; // Id Array of column without innerDimension 
    let innerColumnIdArray: string[] = []; // id Array of column with innerDimension

    for (let dimension of currentTable.Dimensions) {
      if (dimension.Type == 'Column') {
        var column = new Column;
        column.name = dimension.Name;
        column.id = dimension.UniqueIdentifier;
        columnIdArray.push(dimension.UniqueIdentifier);

        if (dimension.InnerDimensions.length != 0) {
          for (let innerDimension of dimension.InnerDimensions) {
            var innerDim = new InnerDimension;
            innerDim.id = innerDimension.UniqueIdentifier;
            innerDim.name = innerDimension.Name;
            column.innerDimension.push(innerDim);
            innerColumnIdArray.push(innerDimension.UniqueIdentifier);
          }
        }
        table.headerColumn.push(column);
      }

      if (dimension.Type == 'Row' && !table.row.filter(row => row.id == dimension.UniqueIdentifier).length) {
        var row = new Row;
        row.isOpen = false;
        row.name = dimension.Name;
        row.id = dimension.UniqueIdentifier;

        if (dimension.InnerDimensions.length != 0) {
          for (let innerDimension of dimension.InnerDimensions) {
            var innerRow = new InnerRow;
            innerRow.id = innerDimension.UniqueIdentifier;
            innerRow.parent = dimension.UniqueIdentifier;
            innerRow.name = innerDimension.Name;
            table.innerRow.push(innerRow);
          }
        }
        table.row.push(row);
      }
    }

    //Drawing the table cells using the length innerColumnIdArray with Id of innerDimension(Column)
    for (let element of innerColumnIdArray) {
      if (table.headerColumn[0].innerDimension.length > 0) {
        for (let row of table.row) {
          var rowValue = new RowValue;
          rowValue.value = '';
          rowValue.idColumn = element;
          row.value.push(rowValue);
        }
        for (let innerRow of table.innerRow) {
          var innerRowValue = new InnerRowValue;
          innerRowValue.value = '';
          innerRowValue.idColumn = element;
          innerRow.value.push(innerRowValue);
        }
      }
    }
    //Drawing the table cells using the length columnIdArray  with Id of the Column
    for (let element of columnIdArray) {
      if (table.headerColumn[0].innerDimension.length == 0) {
        for (let row of table.row) {
          var rowValue = new RowValue;
          rowValue.value = '';
          rowValue.idColumn = element;
          row.value.push(rowValue);
        }
      }
    }
    //fill the table with the corresponding values
    for (let value of currentTable.Values) {
      for (let row of table.row) {
        for (let rowValue of row.value) {
          if (value.DimensionsIdentifiers[1] == row.id && value.DimensionsIdentifiers[0] == rowValue.idColumn) {
            rowValue.value = value.Value;
          }
        }
      }
      if (table.innerRow.length != 0) {
        for (let innerRow of table.innerRow) {
          for (let innerRowValue of innerRow.value) {
            if (value.DimensionsIdentifiers[1] == innerRow.id && value.DimensionsIdentifiers[0] == innerRowValue.idColumn) {
              innerRowValue.value = value.Value;
            }
          }
        }
      }
    }
    this.createLineChartFromTable(guiElement, table);
  }

  //Barchart Vertival
  createBarchartVertical(guiElement, currentVerticalBarchart, barchartVertical: BarchartVertical) {
    let identifier: string; //Variable used to get an index.
    let index: number; //Variable used to convert identifier.
    let value: number; //Variable used to replace the comma with the dot.

    //Instance of child BarchartVertical Object.
    if (!barchartVertical) {
      barchartVertical = new BarchartVertical;
      barchartVertical.barChartType = 'bar';
      barchartVertical.title = currentVerticalBarchart.Title;
      guiElement.graphics.push({ type: currentVerticalBarchart.Type, data: barchartVertical });
    }

    barchartVertical.barChartLegend = true;
    barchartVertical.barChartOptions = { scaleShowVerticalLines: false, responsive: true };

    //Insert the distribution elements into the array labels of my object.
    for (let dimension of currentVerticalBarchart.Dimensions) {
      if (dimension.Type == 'XAxis') {
        for (let distribution of dimension.Distribution) {
          barchartVertical.barChartLabels.push(distribution);
        }
      }
      if (dimension.Type == 'YAxis' && !barchartVertical.barChartData.length) {
        dimension.Distribution.forEach((distribution, x) => {
          barchartVertical.barChartData.push({ data: [], label: distribution, type: 'bar', backgroundColor: this.chartColors[x] })
        });
      }
    }

    //Fill the BarchartVerticalData with corresponding values.
    for (let dimension of currentVerticalBarchart.Values) {
      identifier = dimension.DimensionsIdentifiers[1].split("-");
      index = Number(identifier[3]);
      value = dimension.Value.replace(/,/gi, '.');
      var barChartDatas = barchartVertical.barChartData.filter(data => data.type == "bar");
      barChartDatas[index].data.push(Number(value));
    }

    return barchartVertical;
  }

  // Databar
  createDatabar(guiElement, currentDatabar) {
    let identifier: string; //Variable used to get an index.
    let index: number; //Variable used to convert identifier.
    let value: number; //Variable used to replace the comma with the dot.

    //Instance of child Databar Object.
    var databar = new Databar;
    databar.title = currentDatabar.Title;
    databar.column.push(currentDatabar.Dimensions[0].Name, currentDatabar.Dimensions[1].Name);

    //Insert the distribution elements into the array row of my object.
    for (let dimension of currentDatabar.Dimensions) {
      if (dimension.Distribution.length != 0) {
        for (let distribution of dimension.Distribution) {
          databar.row.push({ name: distribution, value: '' });
        }
      }
    }

    //Fill the Databar with corresponding values.
    for (let value of currentDatabar.Values) {
      identifier = value.DimensionsIdentifiers[1].split("-");
      index = Number(identifier[3]);
      value = value.Value.replace(/,/gi, '.');
      databar.row[index].value = Number(value);
    }
    guiElement.graphics.push({ type: currentDatabar.Type, data: databar });
  }

  // Piechart [not-tested]
  createPiechart(guiElement, currentPiechart, piechart: Piechart) {
    let identifier: string; //Variable used to get an index.
    let index: number; //Variable used to convert identifier.
    let value: number; //Variable used to replace the comma with the dot.
    let color: number = 0; //Variable used as an index to bring color to the elements of my PiechartData.

    //Instance of child Piechart Object.
    if (!piechart) {
      piechart = new Piechart;
      piechart.pieChartType = 'pie';
      piechart.title = currentPiechart.Title;
      guiElement.graphics.push({ type: currentPiechart.Type, data: piechart });
    }

    //Insert the distribution elements into the array labels of my object and assign colors of PiechartColors array.
    for (let distribution of currentPiechart.Dimensions[0].Distribution) {
      piechart.label.push(distribution);
      piechart.piechartColors[0].backgroundColor.push(this.chartColors[color++]);
    }

    //Fill the PiechartData with corresponding values.
    for (let value of currentPiechart.Values) {
      identifier = value.DimensionsIdentifiers[0].split("-");
      index = Number(identifier[3]);
      value = value.Value.replace(/,/gi, '.');
      piechart.piechartData.splice(index, 0, value);
    }
  }

  //Linechart [not-tested]
  createLinechart(guiElement, currentLinechart, linechart: Linechart) {
    let identifier: string; //Variable used to get an index.
    let index: number; //Variable used to convert identifier.

    let datasetLength: number; //Length of LinechartData.

    if (!linechart) {
      linechart = new Linechart;
      linechart.lineChartType = 'line';
      linechart.title = currentLinechart.Title;
      guiElement.graphics.push({ type: currentLinechart.Type, data: linechart });
    }
    //Instance of child Linchart Object.
    linechart.lineChartLegend = true;
    linechart.lineChartOptions = { responsive: true };

    //Insert the distribution elements into the array labels of my object.
    for (let dimension of currentLinechart.Dimensions) {
      if (dimension.Type == 'XAxis') {
        for (let distribution of dimension.Distribution) {
          linechart.linechartLabels.push(distribution);
        }
      }
      if (dimension.Type == 'YAxis' && !linechart.linechartData.length) {
        dimension.Distribution.forEach((distribution, x) => {
          linechart.linechartData.push({ data: [], label: distribution })
          linechart.linechartColors.push({ borderColor: this.chartColors[x], backgroundColor: 'rgba(255,255,255,0)', pointBackgroundColor: this.chartColors[x] });
        })
      }
    }

    //Fill the LinechartData with corresponding values.
    for (let value of currentLinechart.Values) {
      identifier = value.DimensionsIdentifiers[0].split("-");
      index = Number(identifier[3]);
      value = value.Value.replace(/,/gi, '.');
      linechart.linechartData[datasetLength - 1].data.push(Number(value))
    }

    return linechart;
  }

  //BarchartHorizontal [not-tested]
  createBarchartHorizontal(guiElement, currentHorizontalBarchart, barchartHorizontal: BarchartHorizontal) {
    let identifier: string; //Variable used to get an index.
    let index: number; //Variable used to convert identifier.
    let value: number; //Variable used to replace the comma with the dot.

    //Instance of child BarchartHorizontal Object.   
    if (!barchartHorizontal) {
      barchartHorizontal = new BarchartHorizontal;
      barchartHorizontal.title = currentHorizontalBarchart.Title;
      barchartHorizontal.barChartType = 'horizontalBar';
      guiElement.graphics.push({ type: currentHorizontalBarchart.Type, data: barchartHorizontal });
    }

    barchartHorizontal.barChartLegend = true;
    barchartHorizontal.barChartOptions = { scaleShowVerticalLines: false, responsive: true };

    //Insert the distribution elements into the array labels of my object.
    for (let dimension of currentHorizontalBarchart.Dimensions) {
      if (dimension.Type == 'YAxis') {
        for (let distribution of dimension.Distribution) {
          barchartHorizontal.barChartLabels.push(distribution);
        }
      }
      if (dimension.Type == 'XAxis' && !barchartHorizontal.barChartData.length) {
        dimension.Distribution.forEach((distribution, x) => {
          barchartHorizontal.barChartData.push({ data: [], label: distribution, type: 'horizontalBar', backgroundColor: this.chartColors[x] })
        })
      }
    }

    //Fill the BarchartHorizontal with corresponding values.
    for (let dimension of currentHorizontalBarchart.Values) {
      identifier = dimension.DimensionsIdentifiers[1].split("-")
      index = Number(identifier[3])
      value = dimension.Value.replace(/,/gi, '.')
      barchartHorizontal.barChartData[index].data.push(Number(value))
    }
  }

  //Bubblechart [not-tested]
  createBubblechart(guiElement, currentBubblechart, bubblechart: BubbleChart) {
    let value: number; //Variable used to replace the comma with the dot.

    //Instance of child BarchartVertical Object.
    if (!bubblechart) {
      bubblechart = new BubbleChart;
      bubblechart.barChartType = 'bubble';
      bubblechart.title = currentBubblechart.Title;
      guiElement.graphics.push({ type: currentBubblechart.Type, data: bubblechart });
    }

    bubblechart.barChartLegend = true;
    bubblechart.barChartOptions = { scaleShowVerticalLines: false, responsive: true };

    bubblechart.barChartData.push({ data: [], label: 'Data', backgroundColor: this.chartColors[0] });

    //Fill the BubbleChartData with corresponding values.
    for (let dimension of currentBubblechart.Values) {
      value = dimension.Value.replace(/,/gi, '.');
      bubblechart.barChartData[0].data.push({ x: dimension.XPosition, y: dimension.YPosition, r: Math.round(dimension.Radius) / 75 }); // 100
    }
  }


  // Method used to create InterpolatedChart Object.
  createInterpolatedChart(guiElement, currentChart, currentInterpolatedchart, oldChart) {
    let identifier: string; //Variable used to get an index.
    let index: number; //Variable used to convert identifier.
    let value: number; //Variable used to replace the comma with the dot.

    //Check InterpolatedChart and type of InterpolatedChart.
    for (let interpolatedChart of currentInterpolatedchart) {
      if (interpolatedChart.Type != 'linechart') continue;

      //Istance of InterpolateChart object.
      var interpolChart = new InterpolatedChart;
      interpolChart.type = "line";

      for (let dimension of interpolatedChart.Dimensions) {
        if (dimension.Type == 'YAxis') {
          dimension.Distribution.forEach((distribution, linechart) => {
            interpolChart.interpolatedChartData.push({ data: [], label: distribution, type: 'line', borderColor: this.chartColors[linechart], backgroundColor: 'rgba(255,255,255,0)', pointBackgroundColor: this.chartColors[linechart], fill: false });
          });
        }
      }

      //Check that interpolateChartData length in case it is a linechart grouped.
      for (let dimension of interpolatedChart.Values) {
        identifier = dimension.DimensionsIdentifiers[1].split("-")
        index = Number(identifier[3])
        value = dimension.Value.replace(/,/gi, '.')
        interpolChart.interpolatedChartData[index].data.push(Number(value));
      }
      //Call method used to join two charts.
      this.interpolatedChartEntry(guiElement, currentChart, interpolChart, oldChart);
    }
  }

  //Method that returns the two joined charts. 
  interpolatedChartEntry(guiElement, currentChart, interpolatedChart, oldChart) {
    //Check container Chart.
    switch (currentChart.Type) {
      case 'vertical_barchart':
        //Method used to create a BarchartVertical.
        var barchartVertical = this.createBarchartVertical(guiElement, currentChart, oldChart);

        //Change color of BarchartverticalData elements.
        for (let i = 0; i < barchartVertical.barChartData.length; i++) {
          barchartVertical.barChartData[i].backgroundColor = this.chartColors[7 + i];
        }
        //Insert InterpolatedChartData into BarchartVerticalData.
        for (let linechart = 0; linechart < interpolatedChart.interpolatedChartData.length; linechart++) {
          var interpolChart = interpolatedChart.interpolatedChartData[linechart];
          var old = barchartVertical.barChartData.filter(data => (data.type == interpolatedChart.type && data.label == interpolChart.label))[0];
          if (old) old.data = old.data.concat(interpolChart.data);
          else barchartVertical.barChartData.splice(linechart, 0, interpolChart);
        }
        break;
      /*case 'linechart': //[not-tested]
        //Method used to create a Linechart.
        var linechart = this.createLinechart(guiElement, currentChart, oldChart);

        //Insert InterpolatedChartData into LinechartData and change color.
        for (let linechartInterpolated = 0; linechartInterpolated < interpolatedChart.interpolatedChartData.length; linechartInterpolated++) {
          linechart.linechartData.splice(linechartInterpolated, 0, interpolatedChart.interpolatedChartData[linechartInterpolated]);
          linechart.linechartColors.push({ borderColor: this.chartColors[linechartInterpolated + 1], backgroundColor: 'rgba(255,255,255,0)', pointBackgroundColor: this.chartColors[linechartInterpolated + 1] })
        }
        break;*/
    }
  }

  //SimpleTable
  createSimpleTable(guiElement, simpleTable, title) {
    //Instance of child Table Object.
    var t = guiElement.graphics.filter(graphic => (graphic.type == simpleTable.Type && graphic.data.headerColumn[0].name == simpleTable.Title))[0];
    var table: Table;
    if (!t) {
      table = new Table;
      table.title = title;

      var column = new Column;
      column.name = simpleTable.Title;
      column.id = "firstColumnAngul";
      table.headerColumn.push(column);

      guiElement.graphics.push({ type: simpleTable.Type, data: table });
    } else table = t.data;

    var newColumns = [];
    for (let dimension of simpleTable.Dimensions) {
      if (dimension.Type == 'Column') {
        var column = new Column;
        column.name = dimension.Name;
        column.id = dimension.UniqueIdentifier;
        newColumns.push(column);
      }

      if (dimension.Type == 'Row' && !table.row.filter(row => row.id == dimension.UniqueIdentifier).length) {
        var row = new Row;
        row.isOpen = false;
        row.name = dimension.Name;
        row.id = dimension.UniqueIdentifier;

        table.row.push(row);
      }
    }
    table.headerColumn = table.headerColumn.concat(newColumns);

    //Drawing the table cells using the length innerColumnIdArray with Id of innerDimension(Column)    
    for (let column of newColumns) {
      for (let row of table.row) {
        var rowValue = new RowValue;
        rowValue.value = '';
        rowValue.idColumn = column.id;
        row.value.push(rowValue);
      }
    }

    //fill the table with the corresponding values
    for (let value of simpleTable.Values) {
      for (let row of table.row) {
        for (let rowValue of row.value) {
          if (value.DimensionsIdentifiers[1] == row.id && value.DimensionsIdentifiers[0] == rowValue.idColumn) {
            rowValue.value = value.Value;
          }
        }
      }
      if (table.innerRow.length != 0) {
        for (let innerRow of table.innerRow) {
          for (let innerRowValue of innerRow.value) {
            if (value.DimensionsIdentifiers[1] == innerRow.id && value.DimensionsIdentifiers[0] == innerRowValue.idColumn) {
              innerRowValue.value = value.Value;
            }
          }
        }
      }
    }
  }

  createLineChartFromTable(guiElement, table) {
    var t = guiElement.graphics.filter(graphic => graphic.type == "linechart")[0];
    var linechart: Linechart;
    if (!t) {
      linechart = new Linechart;
      linechart.title = table.title;
      guiElement.graphics.push({ type: "linechart", data: linechart });
    } else linechart = t.data;

    linechart.lineChartLegend = true;
    linechart.lineChartType = 'line';
    linechart.lineChartOptions = {
      responsive: true,
      scales: {
        xAxes: [{
          offset: true,
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
          }
        }]
      }
    };
    linechart.linechartLabels.length = 0;
    linechart.linechartData = [];
    linechart.linechartColors = [];

    //Insert the distribution elements into the array labels of my object.
    for (let column of table.headerColumn) {
      linechart.linechartLabels.push(column.name);
    }

    table.row.forEach((row, x) => {
      var data_row = [];
      row.value.filter(row => row.idColumn.includes("Score")).forEach(row => {
        data_row.push(Number(row.value.replace(/,/gi, '.')));
      });

      linechart.linechartData.push({ data: data_row, label: row.name, });
      linechart.linechartColors.push({ borderColor: this.chartColors[x], backgroundColor: 'rgba(255,255,255,0)', pointBackgroundColor: this.chartColors[x] })
    });
  }
}
